const React = require("react"),
    PropTypes = require('prop-types'),
    linkUtil = require("linkUtil");
const {Row, Col, Alert} = require("react-bootstrap");

const SolutionHelpLink = require("components/links/SolutionHelpLink");

const Loading = require("components/widgets/Loading"),
    TournamentManagerButton = require("components/links/TournamentManagerButton"),
    TournamentMMRoundButton = require("components/links/TournamentMMRoundButton"),
    FontAwesome = require("components/widgets/FontAwesome"),
    I18n = require("components/widgets/I18n"),
    messages = require("i18n/messages");

const TournamentMMLoader = require("components/tournamentmanage/TournamentMMLoader"),
    TournamentUserGroupFinalPanel = require("components/tournamentmanage/TournamentUserGroupFinalPanel");

const tournamentUserManagerStore = require("stores/TournamentUserManagerStore"),
    tournamentUserManagerActions = require("actions/TournamentUserManagerActions");

const TournamentMMFinalPage = ({tournamentId}) =>{
        return <TournamentMMLoader tournamentId={tournamentId}>
            <TournamentFinalHierarchy />
        </TournamentMMLoader>
};
TournamentMMFinalPage.propTypes = {
    tournamentId: PropTypes.string.isRequired
};
class TournamentFinalHierarchy extends React.Component {
    constructor(props) {
        super(props);
        this.handleTournamentUserChange = this.handleTournamentUserChange.bind(this);
        this.state = {
            tournamentUserManagerStore: tournamentUserManagerStore.getState(),
        }
    }
    componentDidMount() {
        tournamentUserManagerStore.listen(this.handleTournamentUserChange);
        if (!this.props.tournament.isTypeCupMaster()) {
            tournamentUserManagerActions.loadTournamentUsers.defer(this.props.tournament, this.state.tournamentUserManagerStore.hideDeleted);
            tournamentUserManagerActions.loadTournamentUserGroups.defer(this.props.tournament, this.state.tournamentUserManagerStore.hideDeleted);
        }
    }
    componentWillUnmount() {
        tournamentUserManagerStore.unlisten(this.handleTournamentUserChange);
    }
    handleTournamentUserChange(state) {
        this.setState({tournamentUserManagerStore: state});
    }
    render() {
        const {tournament, tournamentRoundMap, runningTRounds, user, loadingRounds} = this.props;
        const {tournamentUserManagerStore} = this.state;
        // show elements for a normal tournament
        return (<React.Fragment>
            <Row>
                <Col lg={12}>
                    <h1>{tournament.getName() + ", " + tournament.getTournamentDate()}</h1>
                    <SolutionHelpLink articleID="42000037355" />
                </Col>
            </Row>

            <Row>
                <Col xs={12}>
                    {
                        runningTRounds.length > 0 && tournament.isPublished() && tournament.isTodayInTournamentDateRange()?
                            <Alert bsStyle="warning"><FontAwesome icon="exclamation-triangle"/><I18n code="tournament.live.noStartedRounds"/>&nbsp;&nbsp;<TournamentManagerButton tournament={tournament} /> </Alert> : null
                    }
                </Col>
            </Row>
            {
                loadingRounds ? <Row><Col lg={12}><Loading/></Col></Row> :
                    <Row>
                        {
                            tournamentRoundMap.finale != null && tournamentRoundMap.finale.length > 0 ?
                                <TournamentUserGroupFinalPanel user={user} tournament={tournament}
                                                               finalRounds={tournamentRoundMap.finale}
                                                               tournamentUserStore={tournamentUserManagerStore}/>
                                : <Col lg={12}><Alert bsStyle="warning"><I18n code="tournament.final.noRounds"/>&nbsp;<TournamentMMRoundButton tournament={tournament} /></Alert></Col>
                        }
                    </Row>
            }

        </React.Fragment>)
        }
}

TournamentFinalHierarchy.propTypes = {
    user:PropTypes.object.isRequired,
    tournament:PropTypes.object.isRequired,
    tournamentRoundMap:PropTypes.object,
    runningTRounds: PropTypes.array
};
module.exports = TournamentMMFinalPage;
